import Cookies from "js-cookie";
const TokenKey = "artisan-access-token";
const RefreshTokenKey = "artisan-refresh-token";
export function isLogin() {
    var token= Cookies.get(TokenKey);
    if(token) return true;
    else return false;
}
export function logout() {
    delToken();
    delRefreshToken();
}
export function getToken() {
    return Cookies.get(TokenKey);
}
export function setToken(token) {
    Cookies.set(TokenKey, token, {
        expires: 7
    });
}
export function delToken() {
    Cookies.remove(TokenKey);
}
export function getRefreshToken() {
    return Cookies.get(RefreshTokenKey);
}
export function setRefreshToken(token) {
    Cookies.set(RefreshTokenKey, token, {
        expires: 30
    });
}
export function delRefreshToken() {
    Cookies.remove(RefreshTokenKey);
}